// my-app/src/main.ts
import { createApp } from 'vue'
import { createPinia, getActivePinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { setUnauthorizedHandler } from './services/api' 
import { useAuthStore } from './stores/authStore'
import { redirectToClientLogin } from './auth/authRedirect'
import i18n from './i18n'
// Import your library's compiled CSS
import '@myorg/account-lib/style.css';
import '@myorg/menu-editor-lib/style.css';
import '@myorg/booking-lib/style.css'
// Import your app's own CSS (if any)
// import './style.css';
import './output.css'
// import 'account-lib/dist/style.css' // Library's base & component CSS
// 🚨 必須引入這行！SweetAlert2 的樣式才能在手機上正常定位
import 'sweetalert2/dist/sweetalert2.min.css'
import { logger } from '@myorg/type-lib';

// Initialize the library logger using the App's environment
logger.init(import.meta.env.VITE_DEBUG);
logger.log("Env:", import.meta.env.VITE_ENV)
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)

// 統一在 main.ts 綁定真正的處理邏輯
const handleUnauthorized = () => {
  const authStore = useAuthStore();
  authStore.forceLogoutByApi(); // 觸發清空 Store 與特定的 localStorage 憑證
  
  redirectToClientLogin();
};

setUnauthorizedHandler(handleUnauthorized);

// 在掛載 App 之前，先檢查 OAuth 登入狀態
const authStore = useAuthStore()
authStore.checkAuthStatus().finally(() => {
  app.use(router).mount('#app')
})
